// @ts-nocheck
import * as React from "react";

const MinusCircleLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m12 2 .28.004C17.673 2.152 22 6.57 22 12l-.004.28C21.848 17.673 17.43 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2Zm0 2a8 8 0 1 0 0 16l.25-.004A8 8 0 0 0 20 12l-.004-.25A8 8 0 0 0 12 4Zm3 7a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(MinusCircleLine);
